module.exports = __webpack_public_path__ + "img/422.310d5b25.png";